// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auto-resize-textarea{overflow:hidden;resize:none;width:100%;background-color:rgba(0,0,0,0);font-size:14px;border:none;min-height:42px;line-height:1.5;transition:height .1s ease}.auto-resize-textarea::-webkit-scrollbar{width:6px}.auto-resize-textarea::-webkit-scrollbar-track{background:rgba(0,0,0,0)}.auto-resize-textarea::-webkit-scrollbar-thumb{background:#ccc;border-radius:3px}.auto-resize-textarea::-webkit-scrollbar-thumb:hover{background:#999}", ""]);
// Exports
module.exports = exports;
